import { Map, MessageCircle, Clapperboard, Settings } from "lucide-react";

const items = [
  { key: "map", label: "Mapa", Icon: Map, testid: "nav-map-btn" },
  { key: "chat", label: "Catalina", Icon: MessageCircle, testid: "nav-chat-btn" },
  { key: "podcasts", label: "Pódcasts", Icon: Clapperboard, testid: "nav-podcasts-btn" },
  { key: "settings", label: "Ajustes", Icon: Settings, testid: "nav-settings-btn" },
];

export const BottomNav = ({ view, setView }) => {
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-5 left-1/2 -translate-x-1/2 w-[92%] max-w-md glass rounded-full py-2.5 px-3 flex justify-between items-center z-[700]"
      style={{ boxShadow: "0 8px 32px rgba(0,0,0,0.55)" }}
    >
      {items.map(({ key, label, Icon, testid }) => {
        const active = view === key;
        return (
          <button
            key={key}
            data-testid={testid}
            onClick={() => setView(key)}
            className="relative flex flex-col items-center gap-1 px-4 py-1.5 rounded-full transition-all duration-300"
            style={active ? { background: "rgba(212,175,55,0.12)" } : {}}
          >
            <Icon
              size={21}
              strokeWidth={active ? 2.4 : 1.8}
              className="transition-all duration-300"
              style={{
                color: active ? "#f0c94a" : "#9ca3af",
                filter: active ? "drop-shadow(0 0 8px rgba(245,158,11,0.7))" : "none",
              }}
            />
            <span
              className="text-[10px] tracking-wide font-medium transition-colors duration-300"
              style={{ color: active ? "#f0c94a" : "#6b7280" }}
            >
              {label}
            </span>
          </button>
        );
      })}
    </nav>
  );
};
